<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-task-id-select
              ref="taskIdSelect"
              :pageId="this.$options.name"
              default1LevelOption="all"
              default2LevelOption="all"
              default3LevelOption="all"
              @select-changed="onChangeTaskType"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="searchCond"
              :selected="searchFrame.searchCond"
              codeId="COD_ROLE_SRCH_COND"
              defaultOption="all"
              class="width60"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="searchFrame.searchWord"
              maxlength="50"
              @keyup="onKeyUpInput"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Reset "
            @click="onResetClick"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_shut_wrap">
        <div class="inbox">
          <sui-grid
            ref="grid0"
            :columns="gridColumns0"
            :dataset="'ds0'"
            :showDisplayCountControl="false"
            :multiselect="true"
            @rowselect="gridRowSelect('grid0')"
            @rowunselect="gridRowSelect('grid0')"
          />
        </div>
        <div class="btnbox">
          <ul>
            <li>
              <sui-button
                v-permission:update="this.$options.name"
                type="button"
                class="comm_btn_shut_right"
                :disabled="rightShiftEnable"
                @click="onAddClick"
              />
            </li>
            <li>
              <sui-button
                v-permission:update="this.$options.name"
                type="button"
                class="comm_btn_shut_left"
                :disabled="leftShiftEnable"
                @click="onDeleteClick"
              />
            </li>
          </ul>
        </div>
        <div class="inbox">
          <sui-grid
            ref="grid1"
            :columns="gridColumns1"
            :dataset="'ds1'"
            :showDisplayCountControl="false"
            :multiselect="true"
            @rowselect="gridRowSelect('grid1')"
            @rowunselect="gridRowSelect('grid1')"
          />
          <div class="btn_wrap">
            <div class="info">
              {{ $t('MSG_TXT_PRMSN_LVL_DESC') }}
            </div>
          </div>
        </div>
      </div>
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:read="this.$options.name"
          type="button"
          class="comm_btn_border"
          @click="closePagePopup(false)"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          v-permission:update="this.$options.name"
          type="button"
          class="comm_btn_solid"
          @click="onSaveClick"
        >
          {{ $t('MSG_BTN_SAVE') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMU_00014', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageInitialData: {
      type: Object,
      default() {
        return {};
      },
    },
    closePagePopup: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      searchFrame: {
        searchCond: {
          key: '',
          label: '',
        },
        searchWord: '',
        taskId: '',
        searchFieldOldText: '',
      },
      selectedTaskList: [],
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_ROLE_ID'),
        datafield: 'roleId',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_ROLE_NAME'),
        datafield: 'roleName',
      }, {
        text: this.$t('MSG_TXT_ROLE_ALIAS'),
        datafield: 'roleNickName',
        width: 80,
      }, {
        text: this.$t('MSG_TXT_TASK_TYPE'),
        datafield: 'taskName',
        width: 240,
      }],
      localdata1: [],
      gridColumns1: [{
        text: this.$t('MSG_TXT_ROLE_ID'),
        datafield: 'roleId',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_ROLE_NAME'),
        datafield: 'roleName',
      }, {
        text: this.$t('MSG_TXT_ROLE_ALIAS'),
        datafield: 'roleNickName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_ALL'),
        datafield: 'permissionAll',
        createwidget: (row, column, value, htmlElement) => {
          const editorFactory = utils.getGridCellFactory();
          const instance = editorFactory.createCellCheckbox(row, column, value, htmlElement, {
          }, this.ds1, this.$refs.grid1);
          instance.getComponentInstance().$on('input', () => {
            const data = instance.getCurrentDataRow();
            if (utils.isEqual(data.permissionAll, 'Y')) {
              data.permissionLevel = 63;
              data.permissionInstance.setValue(data.permissionLevel);
            }
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '40px',
      }, {
        text: this.$t('MSG_TXT_PRMSN_LVL'),
        datafield: 'permissionLevel',
        createwidget: (row, column, value, htmlElement) => {
          const instance = utils.getGridCellFactory().createCellPermissionCheckbox(row, column, value, htmlElement, {
            checkDisabledFunction: this.permissionDisableState,
          }, this.ds1, this.$refs.grid1);
          const rowindex = instance.getDatasetIndex();
          this.ds1.data[rowindex].permissionInstance = instance.getComponentInstance();
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 150,
      }],
      selectedPageId: '',
      selectPermissionLevel: 1,
      pmsDisableFlag: false,
      disabledYn: 'N',
      rightShiftEnable: true,
      leftShiftEnable: true,
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'roleId', type: 'string', map: 'roleId' },
      { name: 'roleName', type: 'string', map: 'roleName' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'roleNickName', type: 'string', map: 'roleNickName' },
    ],
  }, {
    id: 'ds1',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'roleId', type: 'string', map: 'roleId' },
      { name: 'roleName', type: 'string', map: 'roleName' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'roleNickName', type: 'string', map: 'roleNickName' },
      { name: 'permissionLevel', type: 'string', map: 'permissionLevel' },
      { name: 'permissionAll', type: 'string', map: 'permissionAll' },
      { name: 'permissionInstance', type: 'object', map: 'permissionInstance' },
    ],
  }],
  mounted() {
    this.$nextTick(() => {
      this.selectedPageId = this.pageInitialData.selectedPageId;
      this.selectPermissionLevel = this.pageInitialData.selectPermissionLevel;
      this.pmsDisableFlag = this.pageInitialData.pmsDisableFlag;
      this.disabledYn = this.pageInitialData.disabledYn;
      if (!this.pmsDisableFlag) {
        this.pmsDisableFlag = false;
      }
      if (utils.isEmpty(this.selectPermissionLevel)) {
        this.selectPermissionLevel = 1;
      }
      if (utils.isEmpty(this.disabledYn)) {
        this.disabledYn = 'N';
      }
      if (!utils.isEmpty(this.selectedPageId)) {
        this.rolePageListLoad();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    rolePageListLoad() {
      http.request(this.$options.name, 'DTS_CMA_00040', {
        query: {
          roleObjectId: this.selectedPageId,
          roleObjectTypeCode: 'P',
        },
      }).then(res => {
        utils.forEach(res.data, data => {
          const { roleName, taskName, roleNickName } = data.roleInfo;
          utils.assign(data, {
            roleName,
            taskName,
            roleNickName,
          });
        });
        this.ds1.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    onChangeTaskType(value) {
      this.selectedTaskList = value;
    },
    onResetClick() {
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'searchCond')) {
          this.$refs.searchCond.reset();
          this.$refs.taskIdSelect.reset();
        } else {
          this.searchFrame[key] = '';
        }
      });
    },
    getSearchData() {
      const data = {};
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'searchCond')) {
          data[key] = value.key;
        } else {
          data[key] = value;
        }
      });
      utils.forEach(this.selectedTaskList, task => {
        if (!utils.isEqual(task.key, 'ALL')) {
          utils.set(data, 'taskId', task.key);
        }
      });
      return data;
    },
    onSearchClick() {
      const searchData = this.getSearchData();
      http.request(this.$options.name, 'DTS_CMA_00001', {
        query: searchData,
      }).then(res => {
        this.ds0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    onAddClick() {
      const selected = this.ds0.getSelectedRawData();
      const added = this.ds1.getRawData();
      const newList = [];
      utils.forEach(selected, data => {
        if (utils.findIndex(added, { roleId: data.roleId }) === -1) {
          const clone = utils.assign(data, { permissionLevel: this.selectPermissionLevel, permissionAll: this.disabledYn });
          newList.push(clone);
        }
      });
      this.ds0.clearSelection();
      this.ds1.addRows(newList);
    },
    onDeleteClick() {
      const selected = this.ds1.getSelectedIndexes();
      this.ds1.deleteRows(selected);
    },
    getSaveData(datasetList) {
      const list = [];
      if (datasetList.length > 0) {
        utils.forEach(datasetList, data => {
          list.push({
            roleId: data.roleId,
            roleObjectId: this.selectedPageId,
            roleObjectTypeCode: 'P',
            permissionLevel: data.permissionLevel,
          });
        });
      } else {
        list.push({
          roleId: '',
          roleObjectId: this.selectedPageId,
          roleObjectTypeCode: 'P',
        });
      }
      return list;
    },
    onSaveClick() {
      const saveData = this.getSaveData(this.ds1.getRawData());
      http.request(this.$options.name, 'DTS_CMA_00041', {
        path: {
          'role-object-id': this.selectedPageId,
        },
        data: saveData,
      }).then(() => {
        utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
          this.closePagePopup(true);
        });
      }).catch(error => {
        console.log(error);
      });
    },
    permissionDisableState(rowData) {
      // return utils.isEmpty(rowData) ? false : utils.isEqual(rowData.permissionAll, 'Y');
      return this.pmsDisableFlag ? true :  utils.isEmpty(rowData) ? false : utils.isEqual(rowData.permissionAll, 'Y' );
    },
    /**
     * 검색조건 특수문자 입력 제한
     */
    onKeyUpInput() {
      const searchFieldNewText = this.searchFrame.searchWord;

      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.searchFrame.searchWord = this.searchFieldOldText;
        });
      } else {
        this.searchFieldOldText = searchFieldNewText;
      }
    },
    gridRowSelect(obj) {
      setTimeout(() => {
        const shiftBtnDisable = this.$refs[obj].ds.selectedRowIds.length > 0 ? false : true;
        if (obj === 'grid0') {
          this.rightShiftEnable = shiftBtnDisable;
        } else {
          this.leftShiftEnable = shiftBtnDisable;
        }
      }, 2);      
    },
  },
};
</script>
<style scoped>
</style>
